import { FC } from 'react';
import { useErrorHandler } from 'react-error-boundary';
import { FiEdit } from 'react-icons/fi';
import { useParams } from 'react-router-dom';
import { PageContainer } from '../../../../components/page/PageContainer';
import { PageHeader } from '../../../../components/page/PageHeader';
import { PageSizer, SizerMode } from '../../../../components/page/PageSizer';
import { breadcrumbName } from '../../../../helpers/Utility';
import { ReadEmployee, useGetStaffByIdQuery } from '../../../../services/gql/graphql.generated';
import { strings as timeshiftStrings } from '../../../../services/translation/strings';
import strings from '../../team.translations';
import { TeamMemberPermissionsEditForm } from './TeamMemberPermissionsEditForm';

interface TeamMemberPermissionsEditProps {}

export const TeamMemberPermissionsEdit: FC<TeamMemberPermissionsEditProps> = () => {
  const { userId } = useParams<'userId'>();
  const handleError = useErrorHandler();

  if (!userId) {
    throw new Error('User ID is required');
  }

  const [{ data: userData, error: userError }] = useGetStaffByIdQuery({
    variables: {
      id: userId
    },
    requestPolicy: 'network-only'
  });

  if (userError) {
    handleError(userError);
  }

  const breadcrumbs = [
    {
      name: strings.teamPageTitle,
      to: '/team'
    },
    {
      name: breadcrumbName(userData!.employee! as ReadEmployee, strings.employeeName),
      to: `/team-member/${userId}`
    },
    {
      name: timeshiftStrings.timeshift.teamMember.permissions.edit,
      to: `/team-member/${userId}/edit-permissions`
    }
  ];

  return (
    <PageContainer>
      <PageHeader
        icon={<FiEdit />}
        pageTitle={
          timeshiftStrings.timeshift.teamMember.permissions.edit +
          ': ' +
          `${userData!.employee!.firstName + ' ' + userData!.employee!.lastName}`
        }
        breadcrumbs={breadcrumbs}
      />
      <PageSizer mode={SizerMode.PAGE}>
        <div className="py-5">
          <TeamMemberPermissionsEditForm employee={userData?.employee as ReadEmployee} />
        </div>
      </PageSizer>
    </PageContainer>
  );
};
